import { CheckmarkIcon, ClockIcon, ParcelIcon } from "../../Icons";
import {
  routeSelector,
  volumesSinceLastReadyTimeSelector,
} from "../../../reducers/matrixProfile/selectors";
import { memo, useEffect, useState } from "react";
import {
  selectedRouteSelector,
  selectedTimeBandSelector,
} from "../../../reducers/ownApp/selectors";
import { zoomLevelSelector } from "../../../reducers/map/selectors";

import { Grid } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { View } from "../../View";
import WarningIcon from "@mui/icons-material/Warning";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { getRouteVolume } from "../../../utils/routes";
import { ROUTE_STATUS } from "../../../consts/routeDetails";
import { DEFAULT_TIMEBAND } from "../../../consts/strings";

const useStyles = makeStyles({
  container: {
    maxHeight: "40px",
    width: "55px",
  },
  line: {
    display: "flex",
    height: "12px",
    lineHeight: "12px",
    fontSize: "12px",
  },
  icon: {
    color: "white",
    height: "12px",
    width: "12px",
  },
  iconContainer: {
    paddingLeft: "4px",
  },
  green: {
    backgroundColor: "#8AC149",
  },
  red: {
    backgroundColor: "#DC0032",
  },
  top: {
    borderRadius: "0 0.125rem 0 0",
  },
  bottom: {
    borderRadius: "0 0 0.125rem 0",
  },
  marginTop: {
    marginTop: "2px",
  },
});

export const RouteVolumes = memo(
  ({
    routeCode,
    postcode,
    individual,
    showAll = false,
    showNoVolume = false,
  }) => {
    const styles = useStyles();
    const selectedRoute = useSelector(selectedRouteSelector);
    const selectedTimeBand = useSelector(selectedTimeBandSelector);
    const volumes = useSelector(volumesSinceLastReadyTimeSelector);
    const route = useSelector(routeSelector(routeCode));
    const zoomLevel = useSelector(zoomLevelSelector);
    const [volume, setVolume] = useState({});

    const isRouteForTimeband = () =>
      (route?.plannedReadyTimeAsString || DEFAULT_TIMEBAND) ===
      selectedTimeBand;
    const getRouteStatusIcon = (routeStatus) => {
      switch (routeStatus) {
        case ROUTE_STATUS.DUTY_EXCEEDED:
          return <WarningIcon className={clsx(styles.icon, styles.red)} />;
        case ROUTE_STATUS.OPPORTUNITY:
          return <ClockIcon className={clsx(styles.icon, styles.red)} />;
        case ROUTE_STATUS.OK:
          return <CheckmarkIcon className={clsx(styles.icon, styles.green)} />;
        default:
          return;
      }
    };

    useEffect(() => {
      setVolume(
        getRouteVolume({
          routeCode,
          route,
          postcode,
          volumes,
          zoomLevel,
          showAll,
          individual,
          selectedRoute,
          selectedTimeBand,
        })
      );
    }, [
      individual,
      postcode,
      route?.stops,
      routeCode,
      selectedRoute,
      selectedTimeBand,
      showAll,
      volumes,
      zoomLevel,
      route,
    ]);

    return showAll ||
      showNoVolume ||
      (routeCode && isRouteForTimeband()) ||
      !!volume.stops ? (
      <Grid container item direction={"column"} className={styles.container}>
        <Grid item container justifyContent={"flex-column"}>
          <Grid
            item
            className={clsx(styles.line)}
            container
            justifyContent={"flex-end"}
          >
            {volume.stops}
            <View className={clsx(styles.iconContainer, styles.top)}>
              <LocationOnIcon className={clsx(styles.icon, styles.green)} />
            </View>
          </Grid>
          <Grid
            item
            className={clsx(styles.line, styles.marginTop)}
            container
            justifyContent={"flex-end"}
          >
            {volume.parcels}
            <View className={clsx(styles.iconContainer, styles.top)}>
              <ParcelIcon className={clsx(styles.icon, styles.green)} />
            </View>
          </Grid>
          {route?.routeOptimisation?.routeStatus && (
            <Grid
              item
              container
              className={clsx(styles.line, styles.marginTop)}
              justifyContent={"flex-end"}
            >
              <View className={clsx(styles.iconContainer)}>
                {getRouteStatusIcon(route.routeOptimisation.routeStatus)}
              </View>
            </Grid>
          )}
        </Grid>
      </Grid>
    ) : null;
  }
);
